import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Features } from './components/features'
import { FAQ } from './components/faq'
import { Download } from './components/download'
import { Footer } from './components/footer'
import { Contact } from './components/contact'
import { About } from './components/about'
import { Gallery } from './components/gallery'
import { WebApp } from './components/WebApp'
import { Feedback } from './components/feedback'
import JsonDataEt from './data/data.json'
import JsonDataEn from './data/data-en.json'
import useAnalytics from './components/useAnalytics';

const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'et';
  })
  const { initializeAnalytics, trackEvent } = useAnalytics();

  useEffect(() => {
    initializeAnalytics();
  }, [initializeAnalytics]);

  useEffect(() => {
    const data = language === 'et' ? JsonDataEt : JsonDataEn
    setLandingPageData(data)

    localStorage.setItem('language', language);

    const path = window.location.pathname;
    const search = window.location.search;
    if (path === '/privacy-policy') {
      const newPath = language === 'et'
        ? '/privacy_policy_et.html'
        : '/privacy_policy.html';
      window.location.href = newPath + search;
    }
  }, [language])

  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const id = hash.split('?')[0];
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  useEffect(() => {
    document.documentElement.classList.add('js-reveal');
    const elements = document.querySelectorAll('.reveal');
    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach((el) => el.classList.add('visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [language]);

  const handleNavClick = (e) => {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      trackEvent('Navigation', 'Click', targetId);
    }
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang)
  }

  return (
    <div>
      <Navigation
        data={landingPageData.Navigation}
        currentLanguage={language}
        onLanguageChange={handleLanguageChange}
        onNavClick={handleNavClick}
      />
      <div className='reveal'>
        <Header data={landingPageData.Header} onNavClick={handleNavClick} />
      </div>
      <div className='reveal'>
        <Features
          data={landingPageData.Features}
          header={landingPageData.FeaturesHeader}
        />
      </div>
      <div className='reveal'>
        <WebApp />
      </div>
      <div className='reveal'>
        <Download data={landingPageData.Download} />
      </div>
      <div className='reveal'>
        <FAQ data={landingPageData.FAQ} />
      </div>
      <div className='reveal'>
        <About data={landingPageData.About} />
      </div>
      <div className='reveal'>
        <Gallery />
      </div>
      <div className='reveal'>
        <Feedback data={landingPageData.Feedback} />
      </div>
      <div className='reveal'>
        <Contact data={landingPageData.Contact} />
      </div>
      <Footer
        data={landingPageData.Footer}
        currentLanguage={language}
      />
    </div>
  )
}

export default App